const digest = '2c54897e508fc48ee05a8ffd84ff40d21470f8eb73488948c33aa655be8035ec';
const css = `._tooltip_yn6fz_1{border-radius:.5rem;max-width:90vw;outline:none;position:absolute;top:3.25rem;width:20rem;z-index:80}._tooltipVariant_yn6fz_11{border:1px solid #e0e0e0;border-radius:1rem;outline:none;position:absolute;width:340px;z-index:80}@media (max-width:799px){._tooltipVariant_yn6fz_11,._tooltip_yn6fz_1{border-radius:0;bottom:0;left:0!important;max-width:none;position:fixed;right:0;top:0;width:auto;z-index:var(--above_C2C,109000)}}._tooltipBody_yn6fz_44{flex:1;overflow-y:auto}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'tooltip': '_tooltip_yn6fz_1', 'tooltipVariant': '_tooltipVariant_yn6fz_11', 'tooltipBody': '_tooltipBody_yn6fz_44' };
export const tooltip = '_tooltip_yn6fz_1';
export const tooltipVariant = '_tooltipVariant_yn6fz_11';
export const tooltipBody = '_tooltipBody_yn6fz_44';
export { css, digest };